var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 5%"}},[_c('h1',{staticStyle:{"font-weight":"bold"},attrs:{"align":"left"}},[_vm._v(" 单据编号:"+_vm._s(this.$route.query.fbillno))]),_vm._v(" "),_c('a-table',{style:({background:'url('+_vm.imagePath+')'}),attrs:{"columns":_vm.columns,"data-source":_vm.data,"loading":_vm.loading}}),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9912016","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PickData.vue
// module id = null
// module chunks = 